module.exports = __webpack_public_path__ + "static/media/trash-can_red.d3f987e6.svg";